import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Ship, 
  BarChart3, 
  Settings, 
  Calendar,
  FileText,
  Users,
  Bell,
  HelpCircle,
  ChevronRight
} from 'lucide-react';

const Sidebar = ({ isOpen }) => {
  const navItems = [
    { path: '/', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
    { path: '/maintenance', icon: <Ship size={20} />, label: 'Maintenance' },
    // { path: '/analytics', icon: <BarChart3 size={20} />, label: 'Analytics' },
    // { path: '/calendar', icon: <Calendar size={20} />, label: 'Calendar' },
    // { path: '/reports', icon: <FileText size={20} />, label: 'Reports' },
    // { path: '/users', icon: <Users size={20} />, label: 'Users' },
    // { path: '/notifications', icon: <Bell size={20} />, label: 'Notifications' },
    { path: '/settings', icon: <Settings size={20} />, label: 'Settings' },
  ];

  return (
    <aside className={`
      fixed inset-y-0 left-0 z-30 w-64 bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700 
      transform transition-transform duration-300 ease-in-out lg:relative lg:translate-x-0
      ${isOpen ? 'translate-x-0' : '-translate-x-full'}
    `}>
      <div className="h-full flex flex-col">
        <div className="p-16">
          <div className="flex items-center space-x-3">
            
          
          </div>
        </div>

        <nav className="flex-1 px-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `
                flex items-center justify-between px-4 py-3 rounded-lg transition-all
                ${isActive 
                  ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' 
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                }
              `}
            >
              <div className="flex items-center space-x-3">
                {item.icon}
                <span className="font-medium">{item.label}</span>
              </div>
              <ChevronRight size={16} />
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
          <div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
            <div className="flex items-center space-x-2 mb-2">
              <HelpCircle size={18} className="text-blue-600 dark:text-blue-400" />
              <span className="text-sm font-medium text-gray-900 dark:text-white">Need help?</span>
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400 mb-3">
              Contact our support team for assistance
            </p>
            <a 
              href="mailto:support@dockyard.com"
              className="text-xs text-blue-600 dark:text-blue-400 hover:underline"
            >
              support@dockyard.com
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;